import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "shareAndroid"
const ShareAndroidIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M15.836 16.672C16.382 16.104 17.15 15.75 18 15.75 19.657 15.75 21 17.093 21 18.75S19.657 21.75 18 21.75 15 20.407 15 18.75Q15.001 18.349 15.1 17.979L8.163 14.076C7.617 14.645 6.85 15 6 15 4.343 15 3 13.657 3 12S4.343 9 6 9C6.85 9 7.616 9.354 8.162 9.922L15.1 6.021Q15.001 5.65 15 5.25C15 3.593 16.343 2.25 18 2.25S21 3.593 21 5.25 19.657 8.25 18 8.25C17.15 8.25 16.382 7.895 15.836 7.326L8.9 11.228Q8.999 11.598 9 12 8.998 12.4 8.899 12.77zM18 17.25C17.172 17.25 16.5 17.922 16.5 18.75S17.172 20.25 18 20.25 19.5 19.578 19.5 18.75 18.828 17.25 18 17.25M6 10.5C5.172 10.5 4.5 11.172 4.5 12S5.172 13.5 6 13.5 7.5 12.828 7.5 12 6.828 10.5 6 10.5M18 3.75C17.172 3.75 16.5 4.422 16.5 5.25S17.172 6.75 18 6.75 19.5 6.078 19.5 5.25 18.828 3.75 18 3.75"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default ShareAndroidIcon
